import axios from '@/plugins/axios';
import apiUrls from '@/config/apiUrls';
import { errorToast } from '@/utils/toastUtils';

export const getConfigData = async () => {
  try {
    const url = (apiUrls.getConfData as (origin: string) => string)(window.location.origin);
    return await axios.get(url);
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};
